export class SectionInfo {
  SectionId: number
  SectionCode: string
  SectionName: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByDisplay: string
  UpdateDate: string
  UpdateBy: string
  rowOFFSet: number
  rowFetch: number
}
